const user = [

  {
    path: '/toefl/user/profile/Home',
    name: '个人主页',
    component: resolve => require(['@/view/toefl/user/profile/Home'], resolve),
    meta: {
      title: '个人主页',
      requireAuth: true
    }

  },
  {
    path: '/toefl/user/profile/changePwd',
    name: '修改密码',
    component: resolve => require(['@/view/toefl/user/profile/changePwd'], resolve),
    meta: {
      title: '修改密码',
      requireAuth: true
    }

  },
  // {
  //   path: '/toefl/user/testResults/setsOfExams',
  //   name: '套题模考',
  //   component: resolve => require(['@/view/toefl/user/testResults/setsOfExams'], resolve),
  //   meta: {
  //     title: '套题模考',
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/toefl/user/testResults/sectionsMock',
  //   name: '单项模考',
  //   component: resolve => require(['@/view/toefl/user/testResults/sectionsMock'], resolve),
  //   meta: {
  //     title: '单项模考',
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/toefl/user/testResults/sectionsPractice',
  //   name: '单项练习',
  //   component: resolve => require(['@/view/toefl/user/testResults/sectionsPractice'], resolve),
  //   meta: {
  //     title: '单项练习',
  //     requireAuth: true
  //   }

  // },
  // {
  //   path: '/toefl/user/testResults/sequentialTopics',
  //   name: '顺序话题',
  //   component: resolve => require(['@/view/toefl/user/testResults/sequentialTopics'], resolve),
  //   meta: {
  //     title: '顺序话题',
  //     requireAuth: true
  //   }

  // },
  {
    path: '/toefl/user/wrong/bookMark',
    name: '收藏夹',
    component: resolve => require(['@/view/toefl/user/wrong/bookMark'], resolve),
    meta: {
      title: '收藏夹',
      requireAuth: true
    }
  },
  {
    path: '/toefl/user/wrong/wrongQuestionbank',
    name: '错题本',
    component: resolve => require(['@/view/toefl/user/wrong/wrongQuestionbank'], resolve),
    meta: {
      title: '错题本',
      requireAuth: true
    }
  },
  {
    path: '/toefl/user/wrong/vocabularyBook',
    name: '生词本',
    component: resolve => require(['@/view/toefl/user/wrong/vocabularyBook'], resolve),
    meta: {
      title: '生词本',
      requireAuth: true
    }
  },
  {
    path: '/toefl/user/wrong/sentenceBook',
    name: '句子本',
    component: resolve => require(['@/view/toefl/user/wrong/sentenceBook'], resolve),
    meta: {
      title: '句子本',
      requireAuth: true
    }
  },

  {
    path: '/toefl/user/wrong/Notes',
    name: '备忘录',
    component: resolve => require(['@/view/toefl/user/wrong/Notes'], resolve),
    meta: {
      title: '备忘录',
      requireAuth: true
    }

  },
  {
    path: '/toefl/user/premium/toeflPre',
    name: '托福会员',
    component: resolve => require(['@/view/toefl/user/premium/toeflPre'], resolve),
    meta: {
      title: '托福会员',
      requireAuth: true
    }
  },
  {
    path: '/toefl/user/setting',
    name: '默认设置',
    component: resolve => require(['@/view/toefl/user/setting'], resolve),
    meta: {
      title: '默认设置',
      requireAuth: true
    }
  },

]
export default user;


// WEBPACK FOOTER //
// ./src/router/gre/user.js